import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShareIOS = () => {
  return (
    <g>
      <path d="m2.051 6.52 3.201.004a.75.75 0 0 1 .1 1.491l-.102.007-2.75-.004v6.483h11V8.033l-2.736-.002a.75.75 0 0 1-.742-.649l-.007-.102a.75.75 0 0 1 .649-.741l.102-.007 3.185.004c.541 0 .986.41 1.043.935l.006.114v7.366c0 .54-.41.986-.936 1.043L13.95 16H2.05a1.05 1.05 0 0 1-1.044-.935L1 14.951V7.568c0-.54.41-.985.936-1.042l.115-.007zM8.423.13l.091.074 3.457 3.252a.749.749 0 0 1-.942 1.161l-.086-.07L8.75 2.484v7.825a.75.75 0 0 1-1.493.102l-.007-.102V2.483L5.053 4.551a.75.75 0 0 1-.978.043l-.082-.075a.749.749 0 0 1-.043-.978l.075-.081L7.485.204A.75.75 0 0 1 8.424.13z" />
    </g>
  );
};

export default withIcon(IconShareIOS);
